export const timelineData=[
    {
        "college":"Vishwakarma Institute  of Technology",
        "degree":"B-Tech Computer Engineering",
        "marks":"CGPA - 9.44",
        "startYear":2020,
        "endYear":"Present"
    },
    {
        "college":"M.S Gosavi College",
        "degree":"HSC",
        "marks":"88.61%",
        "startYear":2018,
        "endYear":"2020"
    },
    {
        "college":"New Era English School",
        "degree":"SSC",
        "marks":"89.4%",
        "startYear":2008,
        "endYear":"2018"
    }
];